import script from "./TableInstructor.vue?vue&type=script&setup=true&lang=js"
export * from "./TableInstructor.vue?vue&type=script&setup=true&lang=js"

import "./TableInstructor.vue?vue&type=style&index=0&id=63abce0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63abce0a"]])

export default __exports__